import { put, select, takeLatest } from 'redux-saga/effects'
import { SpecialReportsConstants } from '../store/specialReports.constants'
import { setAutoEmail, setCustomQuestions } from '../store/specialReports.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getSpecialReportsSelector } from '../selectors'
import { ICategory, ISpecialReportsState } from '../store/specialReports.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'

function parseEmails(emails: string): string[] {
  if (!emails || typeof emails !== 'string') {
    return []
  }

  const trimmed = emails.trim()
  if (!trimmed) {
    return []
  }

  return trimmed
    .split(';')
    .map((email) => email.trim())
    .filter((email) => email.length > 0)
}

export function* handleCategoryChange() {
  try {
    const specialReportsState: ISpecialReportsState = yield select(getSpecialReportsSelector)
    const { categories } = specialReportsState

    if (!categories || categories.length === 0) {
      yield put(setAutoEmail([]))
      return
    }

    const selectedCategory: ICategory = categories[0]
    if (!selectedCategory) {
      yield put(setAutoEmail([]))
      return
    }

    if (!selectedCategory.emails) {
      yield put(setAutoEmail([]))
      return
    }

    const emailsArray = parseEmails(selectedCategory.emails)
    yield put(setAutoEmail(emailsArray))
    yield put(setCustomQuestions([]))
  } catch (e) {
    yield put(throwPcrException(`handleCategoryChange() error: ${e}`))
  }
}

export function* handleCategoryChangeSaga() {
  yield takeLatest([SpecialReportsConstants.SET_CATEGORIES], performWithMutexHOG, handleCategoryChange)
}
